import { c as _c } from "react/compiler-runtime";
import { cn } from '@/app/utils/cn';
export const Blockquote = t0 => {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("text-red-500", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M0 17.7778V11.1032C0 7.9399 0.748353 5.44089 2.24506 3.60617C3.76285 1.77145 5.96574 0.569395 8.85375 0V3.28984C6.70356 3.96468 5.25955 5.12456 4.52174 6.76947C4.14229 7.63411 3.98419 8.53038 4.04743 9.45828H9.01186V17.7778H0ZM23.8419 3.28984C21.7128 3.94359 20.2793 5.12456 19.5415 6.83274C19.1199 7.73955 18.9513 8.61474 19.0356 9.45828H24V17.7778H14.9881V11.1032C14.9881 7.89772 15.7576 5.38816 17.2964 3.57454C18.8564 1.76091 21.0382 0.569395 23.8419 0V3.28984Z" fill="currentColor" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" width="29" height="24" viewBox="0 0 29 24" fill="none" className={t1}>{t2}</svg>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};